import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import NavHeader from '../../components/NavHeader/NavHeader';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../components/shared/PageHelmet';
import BlogDetailsArea from './BlogDetailsArea/BlogDetailsArea';
import MainFooter from '../../components/MainFooter/MainFooter';

const BlogDetails = () => {
   const { id } = useParams();
   const [blog, setBlog] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   const formatDate = (dateString) => {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-GB', {
         day: '2-digit',
         month: 'short',
         year: 'numeric',
      }).format(date);
   };

   useEffect(() => {
      if (id) {
         const fetchBlogDetails = async () => {
            try {
               const response = await axios.get(
                  `${process.env.REACT_APP_API_URL}/blogs/${id}/`
               );
               const blogData = {
                  ...response.data,
                  formattedDate: formatDate(response.data.created),
                  categories: response.data.categories.map((category) => category.name),
               };
               setBlog(blogData);
               setLoading(false);
            } catch (err) {
               setError(err.message);
               setLoading(false);
            }
         };

         fetchBlogDetails();
      }
   }, [id]);

   if (loading) {
      return (
         <>
            <PageHelmet pageTitle="Loading..." noIndex path={`/blogDetails/${id}`} />
            <p>Loading...</p>
         </>
      );
   }

   if (error) {
      return (
         <>
            <PageHelmet pageTitle="Blog Details" noIndex path={`/blogDetails/${id}`} />
            <p>Error: {error}</p>
         </>
      );
   }

   const plainContent = (blog.content || '').replace(/<\/?[^>]+(>|$)/g, '');
   const excerpt = plainContent.length > 155 ? `${plainContent.substring(0, 155).trim()}...` : plainContent;

   return (
      <>
         <PageHelmet
            pageTitle={blog.title || 'Blog Details'}
            description={excerpt || undefined}
            path={`/blogDetails/${id}`}
         />
         <NavHeader />
         <main>
            <CommonPageHeader title={blog.title || 'Blog Details'} subtitle="Blog Details" />
            <BlogDetailsArea blog={blog} />
         </main>
         <MainFooter />
      </>
   );
};

export default BlogDetails;
